import React from 'react'
import Footer from '../../Components/Footer'
import Navbar from '../../Components/Navbar'
import Valuation from '../../Components/Valuation'

const Services = () => {
    return (
        <>
            
                <Navbar />
                <Valuation />
                <Footer />
            

        </>
    )
}

export default Services